import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { baseurl } from '../../Baseurl';
import axiosInstance from '../../api/axiosInstance';
export default function Auto() {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [services, setServices] = useState([]);
  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value.trim() === '') {
      setSuggestions([]);
      return;
    }
    const filtered = services.filter((service) =>
      service?.complaints?.toLowerCase()?.includes(value.toLowerCase())
    );
    setSuggestions(filtered);
  };
  useEffect(() => {
    getdataapi();
  }, []);
  const getdataapi = async () => {
    try {
      const response = await axiosInstance.get(`getAllComplaints`);
      if (response.data.success === true) {
        setServices(response.data.data || []);
      } else {
        console.error("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const handleSuggestionClick = (value) => {
    setInputValue(value);
    setSuggestions([]);
  };
  return (
    <div
      className="pc-container"
    >
      <div style={{
        position: 'relative',
        zIndex: 10000, // Max z-index
        overflow: 'visible', // ensure dropdown is not hidden
      }}>
        <div className="pc-content" style={{ position: 'relative' }}>
          <div style={{ position: 'relative' }}>
            <textarea
              value={inputValue}
              onChange={handleChange}
              placeholder="Enter complaint"
              className="form-control"
              style={{ zIndex: 10001, position: 'relative' }}
            />
            {suggestions.length > 0 && (
              <ul
                style={{
                  background: 'white',
                  border: '1px solid #ccc',
                  zIndex: 99999999999999999999999999999999999999999999999999999, // Max possible to stay on top
                  width: '100%',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  padding: 0,
                  listStyle: 'none',
                  margin: 0,
                  boxShadow: '0px 2px 5px rgba(0,0,0,0.2)',
                  marginBottom: "900px"
                }}
              >
                {suggestions.map((item, index) => (
                  <li
                    key={item.id || index}
                    style={{
                      padding: '8px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #eee',
                      backgroundColor: '#fff',
                    }}
                    onClick={() => handleSuggestionClick(item.complaints)}
                  >
                    {item.complaints}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
